import React, { useEffect } from 'react'

import { usePageTitle } from '../../hooks/usePageTitle'
import DataToEditSection from './_components/DataToEditSection'
import DataToResult from './_components/DataToResult'
import FilterSection from './_components/FilterSection'
import { Container } from './style'
import { PageProps, RemarkReport, Remark } from '@/@types/global'
import { configRemark } from '@/api/post'
import { useApp } from '@/stores/AppStore'

const GenerateReport: React.FC<PageProps> = ({ title, subtitle }) => {
  const { setIsLoading, setRemark } = useApp()

  usePageTitle({ title, subtitle })

  useEffect(() => {
    const removeDuplicateRemarks = (items: RemarkReport[]) => {
      items.forEach((item) => {
        const uniqueRemarks: Remark[] = []
        const seenRemarks = new Set()

        item.remarks.forEach((elemt) => {
          const remarkKey = `${elemt.line}-${elemt.remark}`
          if (!seenRemarks.has(remarkKey)) {
            seenRemarks.add(remarkKey)
            uniqueRemarks.push(elemt)
          }
        })

        item.remarks = uniqueRemarks
      })

      return items
    }

    const fetchConfigRemark = async () => {
      try {
        const response = (await configRemark({})) as unknown as {
          items: RemarkReport[]
        }
        const items =
          response && response.items
            ? removeDuplicateRemarks(response.items)
            : null
        setRemark(items ?? [])
      } catch (error) {
        console.error(error)
      } finally {
        setIsLoading(false)
      }
    }
    fetchConfigRemark()
  }, [setIsLoading, setRemark])

  return (
    <Container>
      <FilterSection />
      <DataToEditSection />
      <DataToResult />
    </Container>
  )
}

export default GenerateReport
